export const TextWrapper = ({
  text,
  isHighlighted,
  style,
}: {
  text: string;
  isHighlighted?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <span
      style={{
        fontSize: "14px",
        fontWeight: isHighlighted ? 550 : 400,
        color: "#1F2932",
        userSelect: "none",
        ...style,
      }}
    >
      {text}
    </span>
  );
};
